import React from 'react'
import Dashnav from '../Components/Dashnav'
import Leftmenu from '../Components/Leftmenu'
import DarasaComp from './DarasaComp'

function DarasaReports() {
  return (
    <div>
        <div className='mainContainer'>
            <Leftmenu/>
            <div className='theMainContainer'>
              <Dashnav/>
              <DarasaComp/>
            </div>
        </div>  
    </div>
  )
}

export default DarasaReports